import { render, staticRenderFns } from "./AccountOfferDetails.vue?vue&type=template&id=b81e0ecc"
import script from "./AccountOfferDetails.vue?vue&type=script&lang=ts"
export * from "./AccountOfferDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports